import React, {useRef, useState} from "react";
import FadeInOut from "./FadeInOut";
import {ErrorAlert, Loading} from "./index";

// TabHeader 元件：用來顯示上方日期標籤
const TabHeader = ({dayData, tabId, activeTab, onClick, className}) => {
    if (!dayData) return null;
    const dateParts = dayData.eventDate.split("/");
    return (
        <li
            className={`${className} ${activeTab === tabId ? "active" : ""}`}
            rel={tabId}
            onClick={() => onClick(tabId)}
        >
            <div>
                <h3>
                    <b>
                        {dateParts[1] + "." + dateParts[2]}
                        {dayData.eventWeek && <span>{dayData.eventWeek}</span>}
                    </b>
                </h3>
            </div>
        </li>
    );
};

// AgendaList 元件：用來顯示單一天的議程列表
const AgendaList = ({agenda}) => {
    // 根據項目型別來渲染對應的內容
    const renderAgendaItem = (item, index, agendaList) => {
        // 當前項目為 AGENDA 且下一筆為 SPEAKER 時，視為主題
        if (
            item.type === "AGENDA" &&
            agendaList[index + 1] &&
            agendaList[index + 1].type === "SPEAKER"
        ) {
            return (
                <li className="aganda_item a_topic" key={index}>
                    <div className="aganda_time">{item.time}</div>
                    <div className="aganda_in">
                        <h5>{item.topic}</h5>
                        <h5>{item.topicEn}</h5>
                    </div>
                </li>
            );
        }
        // 當前項目為 AGENDA 且下一筆也是 AGENDA 時，視為一般行程
        if (
            (item.type === "AGENDA" &&
                agendaList[index + 1] &&
                agendaList[index + 1].type === "AGENDA"
            ) || (item.type === "AGENDA" && !agendaList[index + 1])
        ) {
            return (
                <li className="aganda_item" key={index}>
                    <div className="aganda_time">{item.time}</div>
                    <div className="aganda_in">
                        <h5>{item.topic}</h5>
                        <h5>{item.topicEn}</h5>
                    </div>
                </li>
            );
        }
        // 講者項目
        if (item.type === "SPEAKER") {
            return (
                <li className="aganda_item a_speaker" key={index}>
                    <div className="aganda_time">{item.time}</div>
                    <div className="aganda_in">
                        <div className="card_pic">
                            <img src={item.dateSpeaker[0].logoLargeImageIdUrl} alt=""/>
                        </div>
                        <div className="card_txt">
                            <b>{item.dateSpeaker[0].name}</b>
                            <span>
                {item.dateSpeaker[0].jobTitle}, {item.dateSpeaker[0].company}
              </span>
                        </div>
                    </div>
                </li>
            );
        }
        // 焦點座談會項目
        if (item.type === "FOCUS_TALK") {
            return (
                <li className="aganda_item a_talk" key={index}>
                    <div className="aganda_time">{item.time}</div>
                    <div className="aganda_in">
                        <h5>焦點座談會：焦點對談</h5>
                        <div className="a_talkList">
                            <div className="a_host">
                                <h6>主持人</h6>
                                <ul className="host_list">
                                    {item.dateSpeaker
                                        .filter((speaker) => speaker.role === "HOST")
                                        .map((speaker, idx) => (
                                            <li key={idx}>
                                                <div className="card_pic">
                                                    <img src={speaker.logoLargeImageIdUrl} alt=""/>
                                                </div>
                                                <div className="card_txt">
                                                    <b>{speaker.name}</b>
                                                    <span>
                            {speaker.jobTitle}, {speaker.company}
                          </span>
                                                </div>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                            <div className="a_guest">
                                <h6>與談人</h6>
                                <ul className="guest_list">
                                    {item.dateSpeaker
                                        .filter((speaker) => speaker.role === "PANELIST")
                                        .map((speaker, idx) => (
                                            <li key={idx}>
                                                <div className="card_pic">
                                                    <img src={speaker.logoLargeImageIdUrl} alt=""/>
                                                </div>
                                                <div className="card_txt">
                                                    <b>{speaker.name}</b>
                                                    <span>
                            {speaker.jobTitle}, {speaker.company}
                          </span>
                                                </div>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            );
        }
        return null;
    };

    return (
        <article>
            <ul>
                {agenda.map((item, index, agendaList) =>
                    renderAgendaItem(item, index, agendaList)
                )}
            </ul>
        </article>
    );
};

const AgendaGroup = (prop) => {
    const [activeTab, setActiveTab] = useState("tabAg1");
    const tabHeaderRef = useRef(null);
    const tabContainerRef = useRef(null);

    const {data, isLoading, isError} = prop;

    // 更新 handleTabClick，點擊後同時平滑捲動到 tab_container 區塊
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        if (tabContainerRef.current) {
            const headerHeight = document.querySelector('.tabs.groupAganda')?.offsetHeight || 0;
            const elementTop = tabContainerRef.current.getBoundingClientRect().top + window.scrollY - headerHeight * 2;
            window.scrollTo({ top: elementTop, behavior: "smooth" });
        }
    };

    return (
        <div>
            {/* 標籤區塊 */}
            <ul className="tabs groupAganda" ref={tabHeaderRef}>
                <TabHeader
                    dayData={data?.day1}
                    tabId="tabAg1"
                    activeTab={activeTab}
                    onClick={handleTabClick}
                    className="day1"
                />
                <TabHeader
                    dayData={data?.day2}
                    tabId="tabAg2"
                    activeTab={activeTab}
                    onClick={handleTabClick}
                    className="day2"
                />
            </ul>

            <div className="tab_container groupAganda" ref={tabContainerRef}>
                {/* 第一天議程 */}
                <FadeInOut
                    show={activeTab === "tabAg1"}
                    duration={200}
                    className="tab_content"
                >
                    {isLoading && <Loading/>}
                    {isError && <ErrorAlert/>}
                    {!isLoading &&
                        data?.day1?.dateAgendaDList && (
                            <AgendaList agenda={data.day1.dateAgendaDList}/>
                        )}
                </FadeInOut>

                {/* 第二天議程 */}
                <FadeInOut
                    show={activeTab === "tabAg2"}
                    duration={200}
                    className="tab_content"
                >
                    {/* 若第二天也需要 Loading/Error 狀態，可依需求調整 */}
                    {data?.day2?.dateAgendaDList && (
                        <AgendaList agenda={data.day2.dateAgendaDList}/>
                    )}
                </FadeInOut>
            </div>
        </div>
    );
};

export default AgendaGroup;
